// require.context 是 webpack 提供的 API。
// 它的作用是：读取指定目录下的所有符合条件的文件。
// './cn'：表示目标目录是 ./cn，即 src/lang/cn/。
// false：表示不递归子目录（只读取 ./cn/ 这一层）。
// /\.js$/：正则匹配 .js 结尾的文件（只加载 JS 文件）。
const context = require.context('./cn', false, /\.js$/)
// 用于收集每个模块导出的翻译内容
const messages = {}

// context.keys() 会返回一个数组，内容是 ./cn 目录下所有匹配到的 JS 文件路径（如 './menus.js'、'./element.js' 等）。
context.keys().forEach((key) => {
  //这行代码是提取文件名作为模块名。  比如 './menus.js' → 'menus'
  const moduleName = key.replace(/^\.\/(.*)\.js$/, '$1')
  // 加载模块文件内容（通过 require()）并取出 export default 的对象。
  const moduleContent = context(key).default
  // 如果是 element.js，表示是 Element UI 的组件翻译,这种结构是 { el: {...} }，应直接合并到根级别的 messages
  if (moduleName === 'element') {
    Object.assign(messages, moduleContent)
  } else {
    // 否则，就按模块名存入，如：messages.login = {...}，用于按模块访问。
    messages[moduleName] = moduleContent
  }
})

// 导出整合后的语言对象，最终生成结构大致如下：
// {
//   public: {...},      // public.js 中的内容
//   menus: {...},  // menus.js 中的内容
//   el: {...}          // element.js 中的内容合并到了这里
// }
export default messages



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js